exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".singleColorSelector__label___2iAK1:not(:nth-child(1)) {\n  margin-top: 21px; }\n", ""]);

// exports
exports.locals = {
	"label": "singleColorSelector__label___2iAK1"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/SingleColorSelector/singleColorSelector.scss
// module id = 2161
// module chunks = 6